import { Config } from '../../../types/configurations';
import { showTimeIn12HrsFormat } from '../../../utils/timeAndDate';
import AcademiaSectionWrapper from '../AcademiaSectionWrapper';
import SkillBadge from '../Badges/SkillBadge';
import ModalTitle from './ModalTitle';
import ParentModal from './ParentModal';

const ConfigDetailsModal = ({
  config,
  handleModalClose,
}: {
  config: Config;
  handleModalClose: () => void;
}) => {
  // rendering config details modal component here
  return (
    <ParentModal onClick={handleModalClose} customWidthClass='md:w-[700px]'>
      <ModalTitle titleText='service config details' />

      <div>
        <AcademiaSectionWrapper sectionTitle='Associate Info'>
          <h3 className='font-medium text-xl text-base-dark-blue'>
            {config.associate_full_name}
          </h3>

          <div className='mt-1'>
            <div className='grid grid-cols-[130px_8px_1fr] text-base-dark-green text-sm'>
              <p>Working Hours</p>

              <p>:</p>

              <p className='font-medium'>
                {`${showTimeIn12HrsFormat(
                  config.lead_time
                )} - ${showTimeIn12HrsFormat(config.finish_time)}`}
              </p>
            </div>

            <div className='grid grid-cols-[130px_8px_1fr] text-base-dark-green text-sm'>
              <p>Slot Duration</p>

              <p>:</p>

              <p className='font-medium'>{config.slot_duration} Mins.</p>
            </div>

            <div className='grid grid-cols-[130px_8px_1fr] text-base-dark-green text-sm'>
              <p>Buffer Time</p>

              <p>:</p>

              <p className='font-medium'>
                {config.appointment_buffer_time} Mins.
              </p>
            </div>

            <div className='grid grid-cols-[130px_8px_1fr] text-base-dark-green text-sm'>
              <p>Can Reschedule</p>

              <p>:</p>

              <p
                className={`font-medium ${
                  config.allow_rescheduling
                    ? 'text-base-dark-green'
                    : 'text-base-red'
                }`}
              >
                {config.allow_rescheduling ? 'Yes' : 'No'}
              </p>
            </div>

            {config.allow_rescheduling ? (
              <div className='grid grid-cols-[130px_8px_1fr] text-base-dark-green text-sm'>
                <p>Reschedule Limit</p>

                <p>:</p>

                <p className='font-medium'>{config.reschedule_limit} Times</p>
              </div>
            ) : null}
          </div>
        </AcademiaSectionWrapper>

        <AcademiaSectionWrapper sectionTitle='Working Days'>
          <div className='flex flex-wrap gap-2'>
            {config.working_days_with_names.map((day) => (
              <SkillBadge
                key={day.value}
                badgeLabel={day.day}
                color='#388229'
              />
            ))}
          </div>
        </AcademiaSectionWrapper>

        <AcademiaSectionWrapper sectionTitle='Service Info'>
          <div className='grid grid-cols-1 md:grid-cols-[120px_8px_1fr] text-base-purple'>
            <p className='font-light md:font-normal'>Service Name</p>

            <p className='hidden md:block'>:</p>

            <p className='font-medium'>{config.service_data.name}</p>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-[120px_8px_1fr] text-base-purple mt-2 md:mt-0'>
            <p className='font-light md:font-normal'>Description</p>

            <p className='hidden md:block'>:</p>

            <p className='font-medium'>{config.service_data.description}</p>
          </div>
        </AcademiaSectionWrapper>

        <AcademiaSectionWrapper sectionTitle='Service Rate Info'>
          <div className='grid grid-cols-1 md:grid-cols-[150px_8px_1fr] text-base-light-blue'>
            <p className='font-light md:font-normal'>Conversion Name</p>

            <p className='hidden md:block'>:</p>

            <p className='font-medium'>{config.minute_conversion_data.name}</p>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-[150px_8px_1fr] text-base-light-blue mt-2 md:mt-0'>
            <p className='font-light md:font-normal'>Conversion Rate</p>

            <p className='hidden md:block'>:</p>

            <p className='font-medium'>
              {config.minute_conversion_data.minutes_per_credit} Mins.
              <span className='text-sm text-base-orange'>/Credits</span>
            </p>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-[150px_8px_1fr] text-base-light-blue mt-2 md:mt-0'>
            <p className='font-light md:font-normal'>Description</p>

            <p className='hidden md:block'>:</p>

            <p className='font-medium'>
              {config.minute_conversion_data.description}
            </p>
          </div>
        </AcademiaSectionWrapper>
      </div>
    </ParentModal>
  );
};

export default ConfigDetailsModal;
